module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-24.e81eb38f.jpg";